export const WeightUnits = {
  Unknown: 'Unknown',
  Ounces: 'Ounces',
  Ounce: 'Ounce',
  Grams: 'Grams',
  Gram: 'Gram',
  Kilograms: 'Kilograms',
  Kilogram: 'Kilogram',
  Pounds: 'Pounds',
  Pound: 'Pound',
} as const;

export type WeightUnit = (typeof WeightUnits)[keyof typeof WeightUnits];
